export const APP = 'app';

export const actionTypes = {
    GET_SUBSCRIBED_MSI_VESSELS_REQUEST: `${APP}/getSubscribedMsiVesselsRequest`,
    GET_USER_BY_TOKEN_REQUEST: `${APP}/getUserInfoRequest`,
    GET_SUBSCRIBED_MSI_VESSEL_IMAGE_DATA_REQUEST: `${APP}/getSubscribedMsiVesselImageDataRequest`,
    // SIGN_OUT_REQUEST: `${APP}/signOutRequest`,
}

